import { memo, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { componentResolver } from '../../components'
import {
	OnboardingChildrenScreen,
	OnboardingConcernsScreen,
	OnboardingFooter,
	OnboardingHeader,
	OnboardingLoadingScreen,
	OnboardingSummaryScreen,
} from '../../components/Onboarding'
import { onboardingCurrentPage$ } from '../../reducers/app-misc.slice'
import { landingResolver } from '../../route-resolvers/landingResolver'

const OnboardingNavigator = componentResolver(landingResolver, () => {
	const onboardingCurrentPage = useSelector(onboardingCurrentPage$)

	const isFooterVisible = onboardingCurrentPage != 'loading'

	const pageToShow = useMemo(() => {
		switch (onboardingCurrentPage) {
			case 'summary':
				return <OnboardingSummaryScreen />
			case 'loading':
				return <OnboardingLoadingScreen />
			case 'children':
				return <OnboardingChildrenScreen />
			case 'concerns':
			default:
				return <OnboardingConcernsScreen />
		}
	}, [onboardingCurrentPage])

	return (
		<div className="fixed bg-teal-3hl top-0 left-0 h-screen w-screen z-50 flex flex-col justify-between">
			<OnboardingHeader />
			<div className="flex flex-auto justify-center overflow-y-auto">{pageToShow}</div>
			{isFooterVisible && <OnboardingFooter />}
		</div>
	)
})

export default /* @__PURE__ */ memo(OnboardingNavigator)
